import reservice from './reservice'
import reserviceError from './reserviceError'
import common from './common'
import supplier from './supplier'
import reduxForm from './reduxForm'

// reservice middleware must be the first to load
export default [
  reservice,
  reserviceError,
  common,
  supplier,
  reduxForm
]
